/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { niveauActions } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_042: Question = {
  id: 'pres-042-budget-eradication-eee',
  oldId: '56',
  title: 'Allocation d’un budget annuel alloué à l’éradication des EEE',
  number: '4.4',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 5,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: niveauActions,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_pres_042_v2: Question = question_pres_042;
export const question_pres_042_v3: Question = question_pres_042;
